import { authFetch, headers } from '../_helpers';

export const eventRefereeService = {
  addReferee,
  removeReferee,
  referees,
  availableReferees,
};

/**
 * @param {Number} id
 * @param {String} refereeId
 */
async function addReferee(id, refereeId) {
  const response = await authFetch(
    `/api/Event/${id}/AddReferee/${refereeId}`,
    headers.post(),
  );
  return response;
}

/**
 * @param {Number} id
 * @param {String} refereeId
 */
async function removeReferee(id, refereeId) {
  const response = await authFetch(
    `/api/Event/${id}/RemoveReferee/${refereeId}`,
    headers._delete(),
  );
  return response;
}

/**
 * @param {Number} id
 */
async function referees(id) {
  const response = await authFetch(`/api/Event/${id}/Referees`, headers.get());
  return response;
}

/**
 * @param {Number} id
 */
async function availableReferees(id) {
  const response = await authFetch(
    `/api/Event/${id}/AvailableReferees`,
    headers.get(),
  );
  return response;
}
